module.exports = __webpack_public_path__ + "resources\\localization\\nl-nl.json";


/*****************
 ** WEBPACK FOOTER
 ** ./src/resources/localization/nl-nl.json
 ** module id = 33
 ** module chunks = 0
 **/